// extracted by mini-css-extract-plugin
export default {"slider":"HomePageView_slider__GyujN","cryptoSlider":"HomePageView_cryptoSlider__1Q9An","smart":"HomePageView_smart__1McrN","join":"HomePageView_join__ho91j"};